import PropTypes from "prop-types"
import { useSelector } from "react-redux"

import { IS_JEWLR } from "helpers/application"
import { to_currency } from "helpers/number"
import { cn } from "styles/utils"

const ProductPrice = ({ homepageExp, product }) => {
  const { className: secondMicroBannerClassName, ...secondMicroBannerProps } =
    useSelector((state) => state.sale.second_microbanner?.style) || {}
  const onSale = product.reg !== product.selling
  const savePercent = (
    ((product.reg - product.selling) / product.reg) *
    100
  ).toFixed(0)

  const globaleAttrs = {
    container: {},
    display: {},
    reg: {},
  }
  if (sl.config.global_e_pricing == "fixed") {
    if (onSale) {
      globaleAttrs.reg["data-fp"] =
        `"{${sl.config.site_country_for_analytics}": "${product.reg}"}`

      globaleAttrs.display["data-fp"] =
        `{"${sl.config.site_country_for_analytics}": "${product.selling}"}`
    } else {
      globaleAttrs.display["data-fp"] =
        `{"${sl.config.site_country_for_analytics}": "${product.reg}"}`
    }
  } else {
    globaleAttrs.container["data-ge-product-container"] = true
    if (onSale) {
      globaleAttrs.reg["data-ge-list-price"] = true
      globaleAttrs.display["data-ge-sale-price"] = true
    } else {
      globaleAttrs.display["data-ge-price"] = true
    }
  }

  return (
    <div
      className={cn(
        "body-sm desktop:mb-6 mb-4 inline-flex",
        homepageExp &&
          "desktop:body desktop:flex-row desktop:mb-0 desktop:items-center mb-0 flex-col items-start gap-6 font-semibold uppercase"
      )}
      {...globaleAttrs.container}
    >
      {IS_JEWLR() ? (
        <>
          {onSale ? (
            <>
              <p>
                from{" "}
                <span
                  className={cn(
                    "font-semibold",
                    !homepageExp && "text-emerald"
                  )}
                  data-cy={`collection-product-price-${product.style_code}`}
                  {...globaleAttrs.display}
                >
                  {to_currency(product.selling, { precision: 0 })}
                </span>
                <strike
                  className={cn(
                    "font-semibold",
                    homepageExp ? "text-grey-400 ml-6" : "text-grey-300 mx-6"
                  )}
                  {...globaleAttrs.reg}
                >
                  {to_currency(product.reg, { precision: 0 })}
                </strike>
              </p>
              {homepageExp ? (
                <span
                  className={cn(
                    "bg-primary text-13 leading-16 inline-flex items-center justify-center rounded-full px-10 py-8 font-semibold -tracking-tight text-white",
                    secondMicroBannerClassName
                  )}
                  {...secondMicroBannerProps}
                >
                  {savePercent}% off
                </span>
              ) : (
                <span className="text-emerald mobile:inline block font-semibold">
                  SAVE {savePercent}%
                </span>
              )}
            </>
          ) : (
            <>
              from{" "}
              <span
                className="font-semibold"
                data-cy={`collection-product-price-${product.style_code}`}
                {...globaleAttrs.display}
              >
                {to_currency(product.reg, { precision: 0 })}
              </span>
            </>
          )}
        </>
      ) : (
        <span
          className="text-emerald"
          data-cy={`collection-product-price-${product.style_code}`}
        >
          {to_currency(product.selling, { precision: 0 })}
        </span>
      )}
    </div>
  )
}

ProductPrice.propTypes = {
  homepageExp: PropTypes.bool,
  product: PropTypes.object,
}

export default ProductPrice
